import Formatter from '@/Utils/Formatter';
import { getOrderPaymentStatuses } from '@/Utils/PaymentUtility';
import { paymentStatuses, installmentPlanStatuses } from '@/Models';
import Resources from '@/Resources.js';
import { gridCellStatuses } from '@/Utils/GridUtility';

export function buildInstallmentPlanModel(installmentDetails, convertedDisplayCurrency, currencySelected, isDccEnabled, valueTooltip) {
    const currencySymbol = installmentDetails.currencySymbol;

    const hasPaidInstallment = installmentDetails.status === paymentStatuses.completed;
    const statusColor = {
        [paymentStatuses.deferredWithError]: 'invalid',
        [paymentStatuses.completed]: 'accented',
        [paymentStatuses.canceled]: 'invalid',
    };

    const showApproximateValue = [
        !!convertedDisplayCurrency,
        !hasPaidInstallment,
        !currencySelected,
        !isDccEnabled,
    ].every(v => v);

    const amountToPayDisplay = installmentDetails.amountToPayConverted
        ? installmentDetails.amountToPayConverted
        : installmentDetails.amountToPay;

    const currencySymbolDisplay = currencySelected ? currencySelected.symbol : currencySymbol;

    const installmentPlanModel = [
        {
            condition: !!installmentDetails.status,
            title: Resources.YourPledge.InstallmentPlanStatusLabel,
            value: getOrderPaymentStatuses(installmentDetails.status),
            theme: statusColor[installmentDetails.status],
        },
        {
            condition: true,
            title: Resources.YourPledge.InstallmentPlanPaymentDateLabel,
            value: Formatter.format(installmentDetails.paymentDate, 'd'),
            valueTooltip,
        },
        {
            condition: true,
            title: Resources.YourPledge.InstallmentPlanAmountLabel,
            value: Formatter.format(amountToPayDisplay, 'C2', currencySymbolDisplay),
        },
        {
            condition: showApproximateValue,
            title: Resources.YourPledge.InstallmentPlanApproximateConversionLabel,
            tooltipText: Resources.YourPledge.InstallmentPlanApproximateConversionTooltip,
            value: Formatter.format(installmentDetails.amountToPay / convertedDisplayCurrency?.relativeFactorWithCommission, 'C2', convertedDisplayCurrency?.symbol),
        },
        {
            condition: hasPaidInstallment,
            title: 'divider',
            isDivider: true,
        },
        {
            condition: hasPaidInstallment,
            title: Resources.YourPledge.InstallmentPlanTotalPaidLabel,
            value: Formatter.format(amountToPayDisplay, 'C2', currencySymbolDisplay),
        },
    ];

    return installmentPlanModel.filter(installmentPlanModelItem => {
        if (installmentPlanModelItem.condition) {
            delete installmentPlanModelItem.condition;
            return installmentPlanModelItem;
        }
        return;
    });
}

const goodInstallmentPlanStatuses = [
    installmentPlanStatuses.inProgress,
    installmentPlanStatuses.completed,
];
const badInstallmentPlanStatuses = [
    installmentPlanStatuses.canceled,
];

export function getOrderInstallmentPlanStatusEvaluation(installmentPlanStatus) {
    if (goodInstallmentPlanStatuses.includes(installmentPlanStatus))
        return gridCellStatuses.good;
    if (badInstallmentPlanStatuses.includes(installmentPlanStatus))
        return gridCellStatuses.bad;

    return gridCellStatuses.default;
}